import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Divider, Typography } from '@mui/material';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';

const Props = {
  marginLeftPercentage: PropTypes.number.isRequired,
  textTitle: PropTypes.string.isRequired,
  textDescription: PropTypes.string.isRequired,
};

export default function HeaderInformationMobile({
  marginLeftPercentage,
  textTitle,
  textDescription,
}) {
  const classes = useStyles();

  return (
    <Container>
      <Box
        className={classes.mainInformationHeader}
        style={{ marginLeft: `${marginLeftPercentage}%` }}
        height={0}
      />

      <Box height={160}>
        <Typography className={classes.title} component="h1">
          <b>{textTitle}</b>
        </Typography>

        <Divider className={classes.divider} />

        <Typography className={classes.description} component="h2">
          {textDescription}
        </Typography>

        <Box textAlign="center" pt={2}>
          <NextLink href={`/institutions/book-a-demo`} passHref={true}>
            <CustomButton variant="buttonWhiteTextPurple">Book a Demo</CustomButton>
          </NextLink>
        </Box>
      </Box>
    </Container>
  );
}

HeaderInformationMobile.propTypes = Props;
